module.exports = __webpack_public_path__ + "media/images/pla/pla5-c695ff45393232ca08b3095d5c3bc556.jpg";